/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Wiki_TitleInputs */

const en_mk_preview_wiki_title = /** @type {(inputs: Mk_Preview_Wiki_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep project context close to the work.`)
};

const id_mk_preview_wiki_title = /** @type {(inputs: Mk_Preview_Wiki_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konteks proyek selalu dekat.`)
};

/**
* | output |
* | --- |
* | "Keep project context close to the work." |
*
* @param {Mk_Preview_Wiki_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_wiki_title = /** @type {((inputs?: Mk_Preview_Wiki_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Wiki_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_wiki_title(inputs)
	return en_mk_preview_wiki_title(inputs)
});